import React from "react";
import {
  copyToClipboard,
  formatDate,
  formatNumber,
  trimAddress,
} from "../helper/helper";
import { IoCopyOutline } from "react-icons/io5";
import { getNetwork } from "../helper/evmHelper";

const FiatTransactionsDataTable = ({
  transactions,
  isCode = false,
  isAmount = false,
  isReceivedAmount = false,
  isStatus = true,
  isInvoice = false,
  isTaxAmount = false,
  isTxType = false,
  isAmountAfterTax = false,
}) => {
  const classOfTable = {
    cursor: "pointer",
  };

  console.log("transactions", transactions);

  return (
    <div className="table-box">
      <table className="table">
        <thead>
          <tr>
            <th>SN</th>

            <th>App Name</th>

            <th>Withdrawl Amount</th>
            <th>Currency</th>
            <th>Crypto Value</th>
            <th>Wallet Address</th>

            <th>Time Stamp</th>
            {isStatus && <th>Status</th>}
          </tr>
        </thead>
        <tbody>
          {transactions?.length > 0 ? (
            transactions.map((data, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{data?.appsId?.name}</td>
                <td>{data?.withdrawlAmount}</td>
                <td>{data?.currency}</td>
                <td>{data?.cryptoValue}</td>
                <td>{data?.walletAddress}</td>

                <td>{formatDate(data?.createdAt)}</td>

                {isStatus && (
                  <td>
                    <button
                      className={`status ${
                        data?.status.toUpperCase() === "SUCCESS"
                          ? "success"
                          : data?.status.toUpperCase() === "EXPIRED"
                          ? "error"
                          : "pending"
                      }`}
                      onClick={() => {
                        let explorerURL =
                          getNetwork(data?.chainId).explorerURL + data?.hash;
                        window.open(data?.linkURL ?? explorerURL);
                      }}
                    >
                      {data?.status}
                    </button>
                  </td>
                )}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="12">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    marginTop: "20px",
                  }}
                >
                  <p>Data not found</p>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default FiatTransactionsDataTable;
